var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Badge',_vm._g({style:(_vm.currentTrackStyles),attrs:{"data-test-id":"badge"}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.transl8(_vm.track.name))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }